import { render, staticRenderFns } from "./MomoPointRecord.vue?vue&type=template&id=cc3841e8&"
import script from "./MomoPointRecord.vue?vue&type=script&lang=js&"
export * from "./MomoPointRecord.vue?vue&type=script&lang=js&"
import style0 from "./MomoPointRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports